import React from "react";
import LayoutWrapper from "../../../common/LayoutWrapper";
import StatusQuo from "../../../components/your_wishes/STAUS_QUO";
import StatusQuoFileupload from "../../../components/your_wishes/STAUS_QUO/StatusQuoFileupload";

import {
  customTab,
  nextTab,
  preTab,
  resetTab,
} from "../../../redux/slices/TabSlices";
import { connect } from "react-redux";

const StausQuoPage = ({ currentTab, nextTab, preTab, resetCard }) => {
  const tabMaping = {
    1: <StatusQuo next={nextTab} pre={preTab} />,
    2: <StatusQuoFileupload next={nextTab} pre={preTab} />,
  };

  const renderTabs = () => {
    return tabMaping[currentTab];
  };

  return (
    <LayoutWrapper>
      <>{renderTabs()}</>
    </LayoutWrapper>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StausQuoPage);
